import { Media } from "./media";

export class Destaques {

    constructor(item: Destaques | void) {
        if(item instanceof Object) {
            this.id = item.id;
            this.nome = item.nome;
            this.subnome = item.subnome;
            this.body = item.body;
            this.media = item.media;
            this.typeMedia = Boolean(item.typeMedia);
            this.activo = Boolean(item.activo);
            this.master = Boolean(item.master);
            this.link = item.link;
        }
    }

    id: number = -1;
    master: boolean = false;
    nome: string = "";
    subnome: string = "";
    body: string = "";
    media: string = "";
    typeMedia: boolean = false;
    link: string = "";
    activo: boolean = true;
}
export class DestaquesSend {

    constructor(item: DestaquesSend | void) {
        if(item instanceof Object) {
            this.id = item.id;
            this.nome = item.nome;
            this.subnome = item.subnome;
            this.body = item.body;
            this.media1 = item.media1;
            this.media2 = item.media2;
            this.typeMedia = Boolean(item.typeMedia);
            this.activo = Boolean(item.activo);
            this.master = Boolean(item.master);
            this.userId = item.userId;
            this.link = item.link;
        }
    }

    id: number = -1;
    master: boolean = false;
    nome: string = "";
    subnome: string = "";
    body: string = "";
    media1: Media[] = [];
    media2: string = "";
    typeMedia: boolean = false;
    activo: boolean = true;
    userId: string = "";
    link: string = "";

}
